module.exports = __webpack_public_path__ + "static/media/notification-icon.b14f04ca.svg";